import { PhmsBrandMarkComponent } from '../phms-brand-mark/phms-brand-mark.component';
import { Component, computed, effect, inject, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MastheadSearchComponent } from "./masthead-search/masthead-search.component";
import { BreadcrumbComponent, BreadcrumbItem } from './breadcrumbs/breadcrumb/breadcrumb.component';
import { MatSidenav } from '@angular/material/sidenav';

// EZ
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { ButtonConfig } from "@template-ui/types";

// App shell
import { UserMenuComponent } from './user-menu/user-menu.component';
import { ThemeMenuComponent } from './theme-menu/theme-menu.component';
import { MastheadRubiksCubeComponent } from "./masthead-rubiks-cube/masthead-rubiks-cube.component";
import { ThemeManagerService } from '../../services/Theme/theme-manager.service';
import { LoaderComponent } from "../loader/loader.component";
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ParticipantAlertsService } from "../../services/participant-alerts.service";
import { AppRoutingBaseComponent } from "@app/shared/components/app-routing-base.component";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { FormsModule } from "@angular/forms";
import { KeyValuePairsPipe } from "@template-ui/pipes";

@Component({
  selector: 'app-masthead',
  imports: [
    PhmsBrandMarkComponent,
    // Angular stuff
    CommonModule, RouterLink, FormsModule,
    // Material stuff
    MatIconModule,
    // EZ
    UiLibraryModule,
    BreadcrumbComponent,
    // App shell
    UserMenuComponent,
    ThemeMenuComponent,
    LoaderComponent,
    MastheadSearchComponent,
    ToggleSwitchModule,
    KeyValuePairsPipe
  ],
  templateUrl: './masthead.component.html',
  styleUrl: './masthead.component.scss'
})
export class MastheadComponent extends AppRoutingBaseComponent {
  @Input() pageTitle = '';
  @Input() breadcrumbItems: BreadcrumbItem[] = [];
  @Input() sidenav?: MatSidenav;
  @Input() title: string = 'Riley JMS';
  showSearch: boolean = true;

  themeService = inject(ThemeManagerService);
  alertService = inject(ParticipantAlertsService);

  currentTheme: string = '';

  environment = '';

  // This was it's own component but now reduced to just a EZ Button
  myAlertsButtonConfig: ButtonConfig = {
    id: 'my-alerts-button',
    buttonText: 'My Alerts',
    severity: 'secondary',
    badgeSeverity: "danger",
    routerLink: "my-alerts",
    target: computed(() => this.roles.isDeveloper() ? "_self" : "_blank"),  // Per Gregg 10/28/2025 My Alerts opens in a new tab. Per Kyle 12/22/2025 I don't like it so I've disabled _blank for developers.

    // Passing a signal straight through, this works.
    badgeValue: this.alertService.unreadCount
  };

  cdcNumFromPath = computed(() => {
    this.navigationEndSignal();
    let route: ActivatedRoute = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const params = route.snapshot.params;
    return params['cdcNum'];
  });

  constructor() {

    super();

    this.baseHref = this.appConfigService.appConfig?.env.baseHref || this.baseHref;
    this.title = this.appConfigService.appConfig?.browserAuth?.loginPage?.applicationName || this.title;

    effect(() => {
      const savedTheme = this.themeService.savedThemeSignal();

      this.currentTheme = savedTheme.themeName;

      this.themeMode = savedTheme.themeVariantMode;

      this.setThemeModeIcon();

      const env = this.appConfigService.appConfig?.pipeline.EnvironmentName; //   getEnvVar('Environment');

      if (env && env.toLowerCase() !== 'prod') {
        this.environment = env;
      }
    });

    effect(() => {
      const nav = this.navigationEndSignal();
      this.showSearch = (!!nav && (!nav.url.includes("my-alerts") && !nav.url.includes("/legal"))) ||
        //Add legal dashboards to expose legal search
        (!!nav && nav.url.includes('/legal/chief-counsel') || !!nav && nav.url.includes('/legal/analyst')
          || !!nav && nav.url.includes('/legal/attorney1') || !!nav && nav.url.includes('/legal/attorney3')
          || !!nav && nav.url.includes('/legal/asst-chief-counsel'));
    });
  }

  //homeClick(button: number, ctrlKey: boolean, shiftKey: boolean, altKey: boolean, metaKey: boolean):boolean {
  homeClick(event: MouseEvent) {
    //console.log(`homeClick: ctrlKey=${event.ctrlKey}, shiftKey=${event.shiftKey}, altKey=${event.altKey}, metaKey=${event.metaKey}`);

    const targetElement = event.target as HTMLElement;

    if (event.shiftKey && targetElement.hasAttribute('href')) {
      event.preventDefault();
      window.location.href = targetElement.getAttribute('href') || '';
    }
  }

  themeMode: "System" | "Light" | "Dark" = "System";
  themeModeIcon: string = "computer"; //"computer" | "sunny" | "brightness_6" = "computer";

  setThemeModeIcon() {
    const themeIcons: { [key: string]: string } = {
      'System': 'computer',
      'Light': 'sunny',
      'Dark': 'brightness_6'
    };

    this.themeModeIcon = themeIcons[this.themeMode] || '';
  }

  toggleNavLayout(): void {
    const mode = this.bitsStateService.navMode();
    if (mode === 'hamburger') {
      this.bitsStateService.sideNavOpen.set(false);
      this.bitsStateService.navMode.set('rail');
    } else {
      this.bitsStateService.sideNavOpen.set(false);
      this.bitsStateService.navMode.set('hamburger');
    }
  }

}
